import React from "react";
import { Field, Form } from "formik";
import Input from "../../../components/inputs/Input";
import { useLocalizeStateValue } from "../../../languages/Localize";
import styled from "styled-components";
import Select from "../../../components/inputs/Select";
import { LIVE_PRICE, ONLINE_PRICE } from "../../../config/content-values";

const StyledForm = styled(Form)``;

const PurchaserForm = props => {
    const { strings } = useLocalizeStateValue();
    const {
        values: {
            companyName = "",
            address = "",
            companyIdentificationNumber = "",
            personInCharge = "",
            phone = "",
            email = "",
            conferenceAttendType = null,
            paymentType = null
        },
        handleChange,
        submitCount,
        handleBlur,
        isValid,
        setFieldTouched,
        onValidityChange
    } = props;

    const handleFormSubmit = e => {
        e.preventDefault();
    };

    const onChangeHandler = e => {
        handleChange(e);
        setFieldTouched(e.target.name, true, false);
    };

    const onSelectChangeHandler = (value, name) => {
        props.onFormChange({ [name]: value });
        setFieldTouched(value, true, false);
    };

    const onBlurHandler = e => {
        handleBlur(e);
        props.onFormChange({ [e.target.name]: e.target.value });
    };

    /* eslint-disable */
    React.useEffect(() => {
        onValidityChange(isValid);
    }, [isValid]);
    /* eslint-enable */

    return (
        <StyledForm className="form-container" onSubmit={handleFormSubmit}>
            <Field name="personInCharge">
                {props => (
                    <Input
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        label={strings.register.purchaserForm.personInCharge}
                        submitCount={submitCount}
                        value={personInCharge}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
            <Field name="email">
                {props => (
                    <Input
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        label={strings.register.purchaserForm.email}
                        submitCount={submitCount}
                        value={email}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
            <Field name="companyName">
                {props => (
                    <Input
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        label={strings.register.purchaserForm.companyName}
                        value={companyName}
                        submitCount={submitCount}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
            <Field name="address">
                {props => (
                    <Input
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        label={strings.register.purchaserForm.address}
                        submitCount={submitCount}
                        value={address}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
            <Field name="phone">
                {props => (
                    <Input
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        label={strings.register.purchaserForm.phone}
                        submitCount={submitCount}
                        numberInput
                        maxLength={13}
                        value={phone}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
            <Field name="companyIdentificationNumber">
                {props => (
                    <Input
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        label={strings.register.purchaserForm.companyIdentificationNumber}
                        submitCount={submitCount}
                        value={companyIdentificationNumber}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
            <Field name="conferenceAttendType">
                {props => (
                    <Select
                        options={[
                            {
                                label: `Uživo (${LIVE_PRICE})`,
                                value: "LIVE"
                            },
                            {
                                label: `Online (${ONLINE_PRICE})`,
                                value: "ONLINE"
                            }
                        ]}
                        size="large"
                        onSelect={v => onSelectChangeHandler(v, "conferenceAttendType")}
                        onBlur={onBlurHandler}
                        value={conferenceAttendType}
                        label={strings.register.purchaserForm.conferenceAttendType}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
            <Field name="paymentType">
                {props => (
                    <Select
                        options={[
                            {
                                label: "Platnom karticom",
                                value: "E_PAYMENT"
                            },
                            {
                                label: "Žiralno",
                                value: "WIRE_PAYMENT"
                            }
                        ]}
                        size="large"
                        onSelect={v => onSelectChangeHandler(v, "paymentType")}
                        onBlur={onBlurHandler}
                        value={paymentType}
                        label={strings.register.purchaserForm.paymentType}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
        </StyledForm>
    );
};

export default PurchaserForm;
